import type { SystemPropertyUpdate } from '../systemEditSchema'

export function handleIsBatteryDcConnected(system: any, operation: SystemPropertyUpdate): void {
  let booleanValue: boolean
  if (typeof operation.value === 'boolean') {
    booleanValue = operation.value
  } else if (operation.value === 'true' || operation.value === 1 || operation.value === '1') {
    booleanValue = true
  } else if (operation.value === 'false' || operation.value === 0 || operation.value === '0') {
    booleanValue = false
  } else {
    // Default to false for any other value
    booleanValue = false
  }

  const commands = [
    new window.SetValueCommand(system, 'is_battery_dc_connected_auto', false),
    new window.SetValueCommand(system, 'is_battery_dc_connected', booleanValue),
  ]
  window.editor.execute(new window.MultiCmdsCommand(commands))
}
